import React, { useEffect } from "react";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  numDifferentiation,
} from "../../common/app_constant";
import moment from "moment";
import DocumentCard from "../document_card";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../routes/app/auth/dashboard/store";
import toast from "react-hot-toast";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const renderDocuments = (items) => {
  if (!items || items.length === 0) {
    return (
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">No Documents Uploaded</div>
        </div>
      </div>
    );
  }

  return items.map((item, index) => (
    <div className="col-md-6 mb-2" key={index}>
      <DocumentCard
        detailDocument={item.dms} // Important: pass only the 'dms' object
        documentId={index}
        actionDownload={actionDownload}
      />
    </div>
  ));
};


const EndorsementCard = (props) => {
  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));

  const navigation = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigation("/login");
            break;
          case 401:
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  return (
    <div class="card">
      <div class="card-body">
        <a
          class="text-decoration-none w-100"
          data-bs-toggle="collapse"
          href={`#collapseExample${props?.endorsementIndex}`}
          role="button"
          aria-expanded="false"
          aria-controls={`collapseExample${props?.endorsementIndex}`}
        >
          <div class="d-flex">
            <div className="col-6">
              <p class="mb-0">{props?.detailEndorsement?.reason}</p>
            </div>
            <div class="col-6 text-end">

              <small>
                Endorsement NO. : {props?.detailEndorsement?.endorsement_no}
              </small>
            </div>

          </div>
        </a>
        <div class="collapse" id={`collapseExample${props?.endorsementIndex}`}>
          <div class="row border-top pt-2 mt-1">
            <div class="col-md-6 mt-2">
              <label class="card-label">Endorsement Date :</label>
              <p class="card-value mb-0">
                {props?.detailEndorsement?.endorsement_date}
              </p>
            </div>
            {/* <div class="col-md-6 mt-2">
              <label class="card-label">Endorsement Effective Date</label>
              <p class="card-value mb-0">
                {" "}
                {props?.detailEndorsement?.endo_date2}
              </p>
            </div> */}
            {/* <div class="col-md-6 mt-2">
              <label class="card-label">Policy Type :</label>
              <p class="card-value mb-0">
                {props?.detailEndorsement?.policy_type}
              </p>
            </div> */}
            {/* <div class="col-md-6 mt-2">
              <label class="card-label">Insure Company</label>
              <p class="card-value mb-0">
                {" "}
                {props?.detailEndorsement?.insurer_name}
              </p>
            </div> */}
            {/* <div class="col-md-6 mt-2">
              <label class="card-label">Endorsement Executive</label>
              <p class="card-value mb-0">
                {" "}
                {props?.detailEndorsement?.csc_name}
              </p>
            </div> */}
            {/* <div class="col-md-6 mt-2">
              <label class="card-label">RM Name</label>
              <p class="card-value mb-0">{props?.detailEndorsement?.rm_name}</p>
            </div> */}
            <div class="col-md-6 mt-2">
              <label class="card-label">Status</label>
              {/* <p class="card-value mb-0">{!!props?.detailEndorsement?.status?props?.detailEndorsement?.status:"-"}</p> */}
              <p class="card-value mb-0">
                {props?.detailEndorsement?.status}
              </p>
            </div>
            {/* <div class="col-md-6 mt-2">
              <label class="card-label">Department</label>
              <p class="card-value mb-0">
                {" "}
                {!!props?.detailEndorsement?.department?props?.detailEndorsement?.department: "-"}
              </p>
            </div> */}
            <div class="col-md-6 mt-2">
              {/* <label class="card-label">Endorsement Reason (COPS Remark)</label> */}
              <label class="card-label">Remark</label>
              <p class="card-value mb-0">
                {""}
                {props?.detailEndorsement?.remark}
              </p>
            </div>
          </div>
          <div class="row border-top pt-2 mt-2">
            <div className="col-md-4 border-end ">
              Net Premium :
              <span className="fw-bold ms-1">
                {Number(props?.detailEndorsement?.net_amount).toFixed(2)}
              </span>
            </div>
            {/* <div class="col-md-2 fw-bold border-end">
              GST %:
              <span>
                {props?.detailEndorsement?.endo_gst&&numDifferentiation(props?.detailEndorsement?.endo_gst)}
              </span>
            </div> */}
            <div class="col-md-2 border-end">
              TAX :
              <span className="fw-bold ms-1">
                {Number(props?.detailEndorsement?.gst_amount).toFixed(2)}
              </span>
            </div>
            <div class="col-md-4">
              Total Premium :
              <span className="fw-bold ms-1">
                {Number(props?.detailEndorsement?.total_amount).toFixed(2)}
              </span>
            </div>
          </div>
          <div class="row border-top pt-2 mt-1">
            <div class="col-md-6 border-end">
              Created On:
              <span className="fw-bold ms-1">
                {moment(props?.detailEndorsement?.created_at).format(
                  "DD/MM/YYYY"
                )}
              </span>
            </div>
            <div class="col-md-6  border-end">
              Modified On:
              <span className="fw-bold ms-1">
                {moment(props?.detailEndorsement?.updated_at).format(
                  "DD/MM/YYYY"
                )}
              </span>
            </div>
            <div className="col-12 mt-3 border-top">
  <h6 className="card-label mt-2 text-primary">
    Documents ({props?.detailEndorsement?.endorsementDocuments?.length || 0})
  </h6>
</div>
{renderDocuments(props?.detailEndorsement?.endorsementDocuments)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndorsementCard;
